var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    transform: "translate(14 13)",
    d: "M8.5 9.5L5.5 9.5C2.4625001 9.5 0 11.9625 0 15C0 15.552188 0.44781256 16 1 16L13 16C13.552188 16 14 15.552188 14 15C14 11.9625 11.5375 9.5 8.5 9.5ZM1.5309377 14.5C1.7778125 12.528125 3.4625001 11 5.5 11L8.5 11C10.53625 11 12.221875 12.529688 12.46875 14.5L1.5309372 14.5L1.5309377 14.5ZM6.9999995 8C9.2090626 8 11 6.2090626 11 4C11 1.7909374 9.2090626 0 6.9999995 0C4.7909369 0 2.9999995 1.7909374 2.9999995 4C2.9999995 6.2093749 4.7906246 8 6.9999995 8ZM6.9999995 1.5C8.378437 1.5 9.5 2.621563 9.5 4C9.5 5.378437 8.378437 6.5 6.9999995 6.5C5.6215625 6.5 4.4999995 5.3781252 4.4999995 4C4.4999995 2.621563 5.6218743 1.5 6.9999995 1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.4c1a721024cc6d650d5a4385801c4aa3.svg";
export { ForwardRef as ReactComponent };